<template>
  <div class="ra-page--section">
    <el-row type="flex">
      <el-col :span="24">
        <auth-x-form action="edit" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import AuthXForm from "@/components/Products/AuthX/AuthXForm";

export default {
  name: "AuthXConfiguration",
  components: { AuthXForm },
  data() {
    return {};
  }
};
</script>
